import React, { PureComponent } from 'react';
import { assign } from 'lodash';
import { Modal, Input } from 'antd';

/**
 * 可视化-配置链接-选择自定义链接
 */
export class SelectCustomUrl extends PureComponent<{
    modalConfig?: Record<string, any>;
    onChange: (value: any) => void;
    onCancel: () => void;
    value: any;
    showModal: boolean;
}> {
    customUrl = null;

    constructor(props) {
        super(props);
        this.customUrl = props.value;
    }

    changeTarget = () => {
        const { onChange } = this.props;
        onChange(this.customUrl);
    };

    onCancel = () => {
        const { onCancel } = this.props;
        onCancel();
    };

    change = (e) => {
        this.customUrl = e.target.value;
    };

    render() {
        const { value, showModal, modalConfig = {} } = this.props;
        const props = {};
        assign(
            props,
            {
                title: '自定义链接',
            },
            modalConfig,
            { visible: showModal }
        );
        return (
            <Modal {...props} onOk={this.changeTarget} onCancel={this.onCancel}>
                <Input placeholder="请输入自定义链接" defaultValue={value} onChange={this.change} />
            </Modal>
        );
    }
}
